/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-boolean-value */
import { map, mapObject, constant } from 'underscore';
import PropTypes from 'prop-types';
import React, { useContext, useMemo, useCallback } from 'react';
import classNames from 'classnames';

import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ChoiceGroup } from '@fluentui/react';

import { getPlatforms } from '../utils/platforms';
import { getPickPlatformViewStyle } from '../styles/pick-platform-view-styles';

const PickPlatformViewUnstyled = (props) => {
  const {
    onChangePlatforms,
    isSmartOrExpertMode,
    classes,
    selectedPlatform,
  } = props;
  const i18n = useContext(I18nContext);

  const onChangeSelectedPlatforms = useCallback((_, option) => {
    const platform = option.key;
    onChangePlatforms(platform);
  }, [onChangePlatforms]);

  const platformOptions = useMemo(() => map(getPlatforms(isSmartOrExpertMode), (platformText, platformKey) =>
    ({
      key: platformKey,
      text: platformText,
      imageSrc: '#',
      imageSize: {
        width: 130,
        height: 48,
      },
    })), [isSmartOrExpertMode]);

  return (
    <div className={classNames(classes.container, 'pick-platform-view')}>
      <div className={classNames(classes.description, 'pick-platform-description')}>
        {i18n.getString(_TL_('We will provide steps for adding the tracking tag through the following website platforms.'))}
      </div>
      <ChoiceGroup
        selectedKey={selectedPlatform}
        options={platformOptions}
        onChange={onChangeSelectedPlatforms}
      />
    </div>
  );
};

PickPlatformViewUnstyled.propTypes = {
  onChangePlatforms: PropTypes.func.isRequired,
  isSmartOrExpertMode: PropTypes.bool.isRequired,
  classes: PropTypes.shape(mapObject(
    getPickPlatformViewStyle(),
    constant(PropTypes.string.isRequired)
  )).isRequired,
  selectedPlatform: PropTypes.string,
};

PickPlatformViewUnstyled.defaultProps = {
  selectedPlatform: undefined,
};

export const PickPlatformView = withDefaultStyles(PickPlatformViewUnstyled, getPickPlatformViewStyle);
